import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { API_URL } from "../dashboard/Dashboard";

function EspaceMembre() {
  const [identifiant, setIdentifiant] = useState('');
  const [mdp, setMdp] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${API_URL}/recupererInformations.php?identifiant=${encodeURIComponent(identifiant)}&mdp=${encodeURIComponent(mdp)}`
      );

      const data = await response.json();

      if (data.length > 0) {
        localStorage.setItem('user', JSON.stringify(data[0]));
        navigate('/dashboard');
      } else setError('Identifiant ou mot de passe incorrect.');
    } catch (err) {
      console.error(err);
      setError('Erreur lors de la connexion.');
    }
  };

  return (
    <div className="bg-gris-clair dark:bg-sky-800 text-white min-h-screen overflow-hidden flex flex-col">
      <Header/>
      <main className="flex-1 flex flex-col justify-center items-center px-4">
        <div className="bg-white dark:bg-gris-clair text-gray-800 rounded-2xl shadow-lg p-8 w-full max-w-md">
          <h1 className="text-3xl font-semibold text-center text-sky-700 mb-2">Espace membre</h1>

          <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="identifiant" className="block text-sm font-medium text-gray-600 mb-1">Identifiant</label>
              <input type="text" id="identifiant" name="identifiant" placeholder="Identifiant" value={identifiant}
                onChange={(e) => setIdentifiant(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-500"
              />
            </div>
            
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-600 mb-1">Mot de passe</label>
              <input type="password" id="mdp" name="mdp" placeholder="Mot de passe" value={mdp}
                onChange={(e) => setMdp(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-500"
              />
            </div>

            {error && <p className="text-red-500 text-sm">{error}</p>}

            <button type="submit" className="relative bg-bleu-je text-white py-2 transition duration-300 ease-in-out hover:bg-white hover:text-bleu-je border-2 border-bleu-je font-medium rounded-lg">
              Se connecter
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

export default EspaceMembre;